import jui from 'juijs-graph'
export default jui;


// WEBPACK FOOTER //
// ./~/juijs-chart/src/main.js